var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('base-loading',{attrs:{"isShow":_vm.$store.state.isShowLoading}}),_c('base-snackbar',{attrs:{"isShow":_vm.$store.state.isShowSnackbar,"message":_vm.$store.state.snackbarMessage,"type":_vm.$store.state.snackbarType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }